export const locationHostFactory = (): string => window.location.host;
export const locationOriginFactory = (): string => window.location.origin;
